import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export interface City {
  id: string
  name: string
  nameEn: string
  nameFr: string
  countryCode: string
  regionId: string | null
}

const fetchCities = async ({
  pageParam = '1',
  country,
  countries,
  region,
  regionId,
  regionIds,
  continent,
  continents,
  lang,
  search,
}: FetchParams): Promise<PaginatedResponse<City>> => {
  const params = new URLSearchParams()
  params.append('page', pageParam)
  if (country) {
    params.append('country', country)
  }
  if (countries?.length) {
    countries.forEach((c: string) => params.append('countries', c))
  }
  if (region) {
    params.append('region', region)
  }
  // UI stores `residenceRegions` as UUIDs, so we support filtering cities by `regionId`.
  if (regionId) {
    params.append('regionId', regionId)
  }
  if (regionIds?.length) {
    regionIds.forEach((id: string) => params.append('regionIds', id))
  }
  if (continent) {
    params.append('continent', continent)
  }
  if (continents?.length) {
    continents.forEach((c: string) => params.append('continents', c))
  }
  if (lang) {
    params.append('lang', lang)
  }
  if (search) {
    params.append('search', search)
  }
  
  const { data } = await api.get<PaginatedResponse<City>>(`/cities?${params.toString()}`)
  return data
}

export const usePaginateCities = ({
  country,
  countries,
  region,
  regionId,
  regionIds,
  continent,
  continents,
  lang,
  search,
}: {
  country?: string
  countries?: string[]
  region?: string
  regionId?: string
  regionIds?: string[]
  continent?: string
  continents?: string[]
  lang?: 'en' | 'fr' | 'es'
  search?: string
}) => {
  return usePaginate<City>('cities', fetchCities, { country, countries, region, regionId, regionIds, continent, continents, lang, search })
}

